const roles = {
  store: "store",
  customer: "customer",
  admin: "admin",
};

export default roles;
